import globalStore from '$$globalStore';
import projectComponent from '../../Project';

function onTaskLinkCreated(event) {
  const links = event.innerSettings.collaborationItems.filter(link => projectComponent.userHasProject(link.gantt_id));

  if (links.length) {
    globalStore.commit('tasksModel/addLinks', { links, fromGantt: false }, { root: true });
  }
}

export default onTaskLinkCreated;
